<div class="mvi" [class.mvi--mobile]="isMobile">
  <!-- Mobile form screen only shows a Back link, per Figma -->
  <button
    type="button"
    class="mvi__back"
    *ngIf="isMobile && mobileView == 'form'; else header"
    (click)="mobileView = 'choice'"
  >
    <mat-icon class="material-icons-outlined">arrow_circle_left</mat-icon>
    {{ "missingVehicleInfo.back" | translate }}
  </button>

  <ng-template #header>
    <div class="mvi__header">
      <div class="mvi__title">{{ "missingVehicleInfo.title" | translate }}</div>
      <div class="mvi__subtitle">
        {{ "missingVehicleInfo.subtitle" | translate }}
      </div>
    </div>
    <div class="mvi__divider"></div>
  </ng-template>

  <div class="mvi__body">
    <!-- Vehicle details -->
    <form
      class="mvi__form"
      [formGroup]="frmGroup"
      *ngIf="!(isMobile && mobileView == 'choice')"
    >
      <mat-form-field
        appearance="outline"
        floatLabel="always"
        hideRequiredMarker
        class="mvi__field mvi__field--readonly"
      >
        <mat-label>{{ "missingVehicleInfo.plateNo" | translate }}</mat-label>
        <input matInput [value]="data.request.vehicleNo" disabled />
      </mat-form-field>

      <ng-container *ngFor="let field of fields">
        <ng-container *ngIf="isFieldVisible(field)">
          <!-- Retrieved make / model / year are shown as read-only -->
          <mat-form-field
            appearance="outline"
            floatLabel="always"
        hideRequiredMarker
            class="mvi__field mvi__field--readonly"
            *ngIf="lockedFields.includes(field); else selectField"
          >
            <mat-label>{{ labelKeys[field] | translate }}</mat-label>
            <input matInput [value]="frmGroup.controls[field].value" disabled />
          </mat-form-field>

          <ng-template #selectField>
            <mat-form-field
              appearance="outline"
              floatLabel="always"
        hideRequiredMarker
              class="mvi__field"            >
              <mat-label>{{ labelKeys[field] | translate }}</mat-label>
              <mat-select
                [formControlName]="field"
                [placeholder]="'missingVehicleInfo.select' | translate"
                (selectionChange)="onFieldChange(field)"
                panelClass="mvi-select-panel"
                disableOptionCentering
              >
                <mat-option>
                  <ngx-mat-select-search
                    [(ngModel)]="searchText[field]"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="filterOptions(field)"
                    [searching]="isLoading"
                    [placeholderLabel]="'missingVehicleInfo.search' | translate"
                    [noEntriesFoundLabel]="'missingVehicleInfo.noResult' | translate"
                  >
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option
                  *ngFor="let option of filteredOptions[field]"
                  [value]="option.value"
                >
                  {{ option.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-template>
        </ng-container>
      </ng-container>
    </form>

    <!-- Mobile choice: enter details manually -->
    <button
      type="button"
      class="mvi__know-card"
      *ngIf="isMobile && mobileView == 'choice'"
      (click)="mobileView = 'form'"
    >
      <div>
        <div class="mvi__know-card-title">
          {{ "missingVehicleInfo.knowDetails" | translate }}
        </div>
        <div class="mvi__know-card-desc">
          {{ "missingVehicleInfo.knowDetailsDesc" | translate }}
        </div>
      </div>
      <mat-icon>chevron_right</mat-icon>
    </button>

    <ng-container *ngIf="!(isMobile && mobileView == 'form')">
      <div class="mvi__or">{{ "missingVehicleInfo.or" | translate }}</div>

      <!-- Upload car grant -->
      <div class="mvi__upload">
        <div class="mvi__upload-text">
          <div class="mvi__upload-title">
            {{ "missingVehicleInfo.uploadTitle" | translate }}
          </div>
          <div class="mvi__upload-desc">
            {{ "missingVehicleInfo.uploadDesc" | translate }}
          </div>
        </div>

        <div class="mvi__upload-actions">
          <div class="mvi__upload-row">
            <button
              type="button"
              class="mvi__upload-btn"
              [class.mvi__upload-btn--uploaded]="grantFile"
              (click)="fileInput.click()"
            >
              <mat-icon>{{ grantFile ? "check_circle" : "file_upload" }}</mat-icon>
              {{
                (grantFile ? "missingVehicleInfo.uploaded" : "missingVehicleInfo.upload")
                  | translate
              }}
            </button>
            <ng-container *ngIf="grantFile">
              <button type="button" class="mvi__file-name" (click)="openFile()">
                {{ grantFile.name }}
              </button>
              <mat-icon class="mvi__file-delete" (click)="removeFile()">delete</mat-icon>
            </ng-container>
          </div>
          <input
            #fileInput
            type="file"
            hidden
            accept="image/png,image/jpeg,application/pdf"
            (change)="onFileSelected($event)"
          />
          <div class="mvi__upload-hint">
            🔒 {{ "missingVehicleInfo.uploadHint" | translate }}
          </div>
          <div class="mvi__upload-error" *ngIf="fileError">
            {{ fileError | translate }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="mvi__divider" *ngIf="!isMobile"></div>

  <div class="mvi__footer">
    <button
      type="button"
      mat-flat-button
      class="mvi__submit"
      [disabled]="!canSubmit"
      (click)="submit()"
    >
      <span *ngIf="!isSubmitting">{{ "missingVehicleInfo.submit" | translate }}</span>
      <mat-spinner *ngIf="isSubmitting" diameter="20"></mat-spinner>
    </button>
  </div>
</div>
